import { Component, OnInit, ElementRef, ViewChild, IterableDiffer } from '@angular/core';
import { CfCoreComponent } from '../core/core.component';
import { TemplateService } from '../../services/template-service/template.service';
/**
 * This component renders a wizard footer.
 */
export class CfWizardFooterComponent extends CfCoreComponent implements OnInit {
   wizardFooter;
/**
 * @hidden
 * @param {?} elementRef
 * @param {?} templateService
 */
constructor(public elementRef: ElementRef, /**@hidden */ templateService: TemplateService) { super(elementRef, templateService); }
/**
 * @hidden
 * @return {?}
 */
ngOnInit() {}
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'cf-wizard-footer',
  template: "<ng-container #wizardFooter><ng-content></ng-content></ng-container>",
  styles: [":host { display: flex; flex-direction: row; } "]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: TemplateService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'wizardFooter': [{ type: ViewChild, args: ['wizardFooter', ] },],
};
}

function CfWizardFooterComponent_tsickle_Closure_declarations() {
/** @type {?} */
CfWizardFooterComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfWizardFooterComponent.ctorParameters;
/** @type {?} */
CfWizardFooterComponent.propDecorators;
/** @type {?} */
CfWizardFooterComponent.prototype.wizardFooter;
/** @type {?} */
CfWizardFooterComponent.prototype.elementRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
